import { Navigate } from "react-router-dom";
import Home from "@/pages/home";
import About from "@/pages/about";
import Profile from "@/pages/usercenter/profile";
import Square from "@/pages/square";

import Design from "@/pages/design";
import Writing from "@/pages/writing";
import Laboratory from "@/pages/laboratory";

import ShareInvitation from "@/pages/shareinvitation";
import MyIntegral from "@/pages/integral";
import TaskCenter from "@/pages/task";
import SecuritySet from "@/pages/securityset";
import MyActivities from "@/pages/myactivities";
import ActivityCenter from "@/pages/activitycenter";
import MyHomePage from "@/pages/usercenter/myhomepage";
import FollowAndFans from "@/pages/follow";
import CollectAndLike from "@/pages/collectandlike";
import NewMeeting from "@/pages/writing/newMeeting";
// import HistoryList from "@/pages/writing/historylist";
// import WritingHome from "@/pages/writing/writinghome";
import MessagesCenter from "@/pages/messagescenter";
import Grades from "@/pages/grades";
import MyTeam from "@/pages/team";
import MyCourse from "@/pages/course";
import CreatorCenter from "@/pages/creatorcenter";
import Company from "@/pages/company";
import KnowledgeBase from "@/pages/writing/knowledgeBase";
import AiSearch from "@/pages/writing/search";
import KnowledgeBaseSet from "@/pages/writing/knowledgebaseset";
import CreatorCenterHome from "@/pages/creatorcenter/creatorcenterhome";
import MyAiWorks from "@/pages/creatorcenter/myaiworks";
import CreatorDataCenter from "@/pages/creatorcenter/datacenter";
import RealizationCenter from "@/pages/creatorcenter/realization";
import SchoolOfCreativity from "@/pages/creatorcenter/schoolofcreativity";
import MyModels from "@/pages/creatorcenter/mymodel";
import ModelTraning from "@/pages/creatorcenter/modeltraining";
import SMRoom from "@/pages/smroom";

export default [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/square",
    element: <Square />,
  },
  {
    path: "/ai/design",
    element: <Design />,
  },
  {
    path: "/ai/writing",
    element: <Writing />,
    children: [
      {
        path: "",
        element: <NewMeeting />,
      },
      {
        path: "knowledgebase",
        element: <KnowledgeBase />,
      },
      {
        path: "aisearch",
        element: <AiSearch />,
      },
      {
        path: "knowledgebase-set",
        element: <KnowledgeBaseSet />,
      },
    ],
  },
  // {
  //   path: "/ai/writing",
  //   element: <Writing />,
  //   children: [
  //     {
  //       path: "",
  //       element: <WritingHome />,
  //     },
  //     {
  //       path: "newmeeting",
  //       element: <NewMeeting />,
  //     },
  //     {
  //       path: "history",
  //       element: <HistoryList />,
  //     },
  //   ],
  // },
  {
    path: "/ai/laboratory",
    element: <Laboratory />,
  },
  {
    path: "/ai/smroom",
    element: <SMRoom />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "/profile",
    element: <Profile />,
  },
  {
    path: "/shareinvitation",
    element: <ShareInvitation />,
  },
  {
    path: "/integral",
    element: <MyIntegral />,
  },
  {
    path: "/task",
    element: <TaskCenter />,
  },
  {
    path: "/securityset",
    element: <SecuritySet />,
  },
  {
    path: "/myactivities",
    element: <MyActivities />,
  },
  {
    path: "/activitycenter",
    element: <ActivityCenter />,
  },
  {
    path: "/myhomepage/:id",
    element: <MyHomePage />,
  },
  {
    path: "/followandfans",
    element: <FollowAndFans />,
  },
  {
    path: "/collectandlike",
    element: <CollectAndLike />,
  },
  {
    path: "/messages",
    element: <MessagesCenter />,
  },
  {
    path: "/grades",
    element: <Grades />,
  },
  {
    path: "/team",
    element: <MyTeam />,
  },
  {
    path: "/course",
    element: <MyCourse />,
  },
  {
    path: "/creatorcenter",
    element: <CreatorCenter />,
    children: [
      {
        path: "",
        element: <CreatorCenterHome />,
      },
      {
        path: "aiworks",
        element: <MyAiWorks />,
      },
      {
        path: "mymodels",
        element: <MyModels />,
      },
      {
        path: "modeltraning",
        element: <ModelTraning />,
      },
      {
        path: "datacenter",
        element: <CreatorDataCenter />,
      },
      {
        path: "realization",
        element: <RealizationCenter />,
      },
      {
        path: "schoolofcreativity",
        element: <SchoolOfCreativity />,
      }
    ]
  },
  {
    path: "/company",
    element: <Company />,
  },
  {
    path: "/",
    element: <Navigate to="/" />,
  },
] as {
  path: string;
  element: JSX.Element;
}[];
